import React from "react";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// project import
import router from "./routes";
import ThemeCustomization from "./themes";

// import RTLLayout from 'components/RTLLayout';
import ScrollTop from "./components/ScrollTop";
import Snackbar from "./components/@extended/Snackbar";
import Notistack from "./components/third-party/Notistack";
import { IntlProvider } from "react-intl";
// auth-provider
import { JWTProvider as AuthProvider } from "./contexts/JWTContext";
import { Provider } from "react-redux";
import store from "./store";

import messages_en from "./utils/locales/en.json";
import messages_ar from "./utils/locales/ar.json";

import RTLLayout from "./components/RTLLayout";
import Locales from "./components/Locales";

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //
const messages = {
  ar: messages_ar,
  en: messages_en,
};

const language = "ar";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: 1,
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeCustomization>
      <RTLLayout>
        <Locales>
          <ScrollTop>
            <AuthProvider>
              <>
                <Provider store={store}>
                  <Notistack>
                    <RouterProvider router={router} />
                    <Snackbar />
                  </Notistack>
                </Provider>
              </>
            </AuthProvider>
          </ScrollTop>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  </QueryClientProvider>
);

export default App;
